import React from 'react';

interface SectionHeaderProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Header component for sections with a title and actions
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({ title, children }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="mb-0">{title}</h5>
    {children}
  </div>
);

export default React.memo(SectionHeader);
